import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Divider from '@mui/material/Divider';
import {
    Dialog,
    DialogContent,
    DialogActions,
    DialogTitle,
    Typography,
    TextField
} from '@mui/material';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Controller, useWatch } from "react-hook-form";
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import SaveIcon from '@mui/icons-material/Save';
import { fetchBonoEscolarPorPeriodoAgregar, fetchBonoEscolarPorPeriodoEditar } from '../../../redux/Beneficios/BonoEscolar/BonoEscolarSlice';
import moment from 'moment';

export const AgregarBonoEscolarModal = ({open = false, setOpen, listaBonoEscolarPeriodo = [], bonoEscolarPeriodoEdit = {}, form = {}, setBonoEscolarPeriodoEditar}) => {

    // * ULTIMA POSICION DE LA LISTA.
    const bonoEscolarPeriodo = listaBonoEscolarPeriodo[listaBonoEscolarPeriodo?.length - 1];

    const { 
        formState: { errors },
        control,
        setValue,
        handleSubmit 
    } = form;

    // ? HOOK-WATCH
    const data = useWatch({
        control,
        name: 'bonoEscolarPeriodo'
    })

    // ? HOOK-DISPATCH
    const dispatch = useDispatch();
    
    // * FUNCION USADA EN EL BOTON CANCELAR.
    const cancelAction = () => {
        setOpen(false);
        setBonoEscolarPeriodoEditar({});
    }
    
    // ? HOOK-EFFECT
    useEffect(() => {  

        if(Object.keys(bonoEscolarPeriodoEdit).length > 0){
            setValue('bonoEscolarPeriodo', bonoEscolarPeriodoEdit);
        }
        else{
            setValue('bonoEscolarPeriodo.ano',  bonoEscolarPeriodo?.ano + 1);
            setValue('bonoEscolarPeriodo.fechaInicio', moment(new Date().setFullYear(bonoEscolarPeriodo?.ano + 1)).toISOString())
            setValue('bonoEscolarPeriodo.fechaTermino', moment(new Date().setFullYear(bonoEscolarPeriodo?.ano + 1)).toISOString())
        }

    }, [bonoEscolarPeriodoEdit, listaBonoEscolarPeriodo, open])

    // * FUNCION PARA GUARDAR DATA.
    const onSubmit = ({ bonoEscolarPeriodo }) => {   
        if(bonoEscolarPeriodo.bonoEscolarId === 0){
            dispatch(fetchBonoEscolarPorPeriodoAgregar(bonoEscolarPeriodo))
        }
        else{
            dispatch(fetchBonoEscolarPorPeriodoEditar(bonoEscolarPeriodo))
        }
    }

  return (
    <Dialog
        PaperProps={{ sx: { width: "30%", height: "40%" } }}
        open={open}
        maxWidth='lg'
        >

        <DialogTitle sx={{textTransform: 'uppercase'}} className='text-mem text-center'>{Object.keys(bonoEscolarPeriodoEdit).length === 0 ? 'Nuevo' : 'Editar' } Gratificación Escolar</DialogTitle>
        <Divider />

        <DialogContent>

            <form 
            id='form-registrar-periodo-bono-escolar'
            onSubmit={handleSubmit(onSubmit)}
            >
                <Typography>Año</Typography>
                <input value={data.ano} variant="outlined" sx={{width: '100%'}} className='mb-2 form-control' disabled />

                <Typography>Fecha Inicio</Typography>
                <Controller
                    control={control}
                    name="bonoEscolarPeriodo.fechaInicio"
                    render={({ field: { value, onChange } }) => (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            name='fechaInicio'
                            inputFormat='dd/MM/yyyy'
                            label={" "}
                            mask="__/__/____"
                            value={value}
                            onChange={onChange}
                            renderInput={(params) => (
                            <TextField
                                height={10}
                                className="form-control"
                                style={{ height: 10 }}
                                {...params}
                            />
                            )}
                        />
                        </LocalizationProvider>
                    )}
                />

                <Typography fontSize={14} className="text-danger" hidden={!errors.bonoEscolarPeriodo?.fechaInicio?.message}>
                    {errors.bonoEscolarPeriodo?.fechaInicio?.message}
                </Typography>

                <Typography className='mt-4'>Fecha Término</Typography>
                <Controller
                    control={control}
                    name="bonoEscolarPeriodo.fechaTermino"
                    render={({ field: { value, onChange} }) => (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            name='fechaTermino'
                            inputFormat='dd/MM/yyyy'
                            label={" "}
                            mask="__/__/____"
                            value={value}
                            onChange={onChange}
                            renderInput={(params) => (
                            <TextField
                                height={10}
                                className="form-control"
                                style={{ height: 10 }}
                                {...params}
                            />
                            )}
                        />
                        </LocalizationProvider>
                    )}
                />

                <Typography fontSize={14} className="text-danger" hidden={!errors.bonoEscolarPeriodo?.fechaTermino?.message}>
                    {errors.bonoEscolarPeriodo?.fechaTermino?.message}
                </Typography>
            </form>
            
        </DialogContent>

        <DialogActions className='justify-content-center'>
            <button  onClick={() => cancelAction()} className='btn btn-danger'><DoNotDisturbAltIcon sx={{marginTop: -0.5, marginRight: 0.5}}/>CANCELAR</button>
            <button 
            form='form-registrar-periodo-bono-escolar'
            type='submit' 
            className='btn btn-primary-mem'
            >
                <SaveIcon sx={{marginTop: -0.5, marginRight: 0.5}}/>
                GUARDAR
            </button>
        </DialogActions>

    </Dialog>
  )
}
